<template>
  <div>
    <Lynx-Label label="Cidades" class=" " />

    <v-autocomplete
      :loading="loadingCidades"
      v-model="filtroCidade"
      :items="lista_cidades"
      :search-input.sync="searchQuery"
      label="Selecione a(s) cidades(s)"
      multiple
      dense
      item-text="nome"
      item-value="id"
      @change="clearSearchQuery"
    >
    </v-autocomplete>
  </div>
</template>

<script>
import { showCidadesRequest } from "@/services/requests/estados";

export default {
  props: {
    cidades: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchQuery: null,
      lista_cidades: [],
      loadingCidades: false,
      filtroCidade: [],
    };
  },
  watch: {
    searchQuery: _.debounce(function () {
      if (this.searchQuery.length > 3) {
        this.searchCidades();
      }
    }, 400),
    cidades() {
      for (let i = this.lista_cidades.length - 1; i >= 0; i--) {
        if (!this.filtroCidade.includes(this.lista_cidades[i].id)) {
          this.lista_cidades.splice(i, 1);
        }
      }
      this.lista_cidades.push(...this.cidades.map((cidade) =>
      {
       return {
              id: cidade.id,
              nome: cidade.label,
            };
      })
    );
    },
    filtroCidade(){
      this.$emit('filtrarCidades',this.filtroCidade)
    }
  },
  methods: {
    searchCidades() {
      this.loadingCidades = true;
      showCidadesRequest(this.searchQuery)
        .then((res) => {
          const consultaCidades = res.data.map((item) => {
            return {
              id: item.id,
              nome: item.nome + "-" + item.estado.uf,
            };
          });

          // Remover cidades que não estão no filtroCidade (modificando a lista diretamente)
          for (let i = this.lista_cidades.length - 1; i >= 0; i--) {
            if (!this.filtroCidade.includes(this.lista_cidades[i].id)) {
              this.lista_cidades.splice(i, 1); // Remove a cidade da lista
            }
          }

          this.lista_cidades.push(...consultaCidades);
        })
        .finally(() => (this.loadingCidades = false));
    },
    clearSearchQuery() {
      this.searchQuery = "";
    },
  },
};
</script>